// extracted by mini-css-extract-plugin
export default {"loader":"LoadingFullScreen_loader__8lT-j","message":"LoadingFullScreen_message__vHX8l"};